const AI_USAGE_PERIODS = new Set([7, 30, 90]);

const EVENT_LABEL_KEYS = {
  response: 'RESPONSE',
  handoff: 'HANDOFF',
  resolved: 'RESOLVED',
  error: 'ERROR',
  memory: 'MEMORY',
  faq_suggestion: 'FAQ_SUGGESTION',
  tool_call: 'TOOL_CALL',
  copilot: 'COPILOT',
  document: 'DOCUMENT',
  embedding: 'EMBEDDING',
};

const firstNonNegativeNumber = (...candidates) => {
  const matchedNumber = candidates
    .filter(candidate => candidate !== null && candidate !== undefined)
    .map(candidate => Number(candidate))
    .find(candidate => Number.isFinite(candidate));

  return Math.max(0, matchedNumber ?? 0);
};

export const normalizeAiUsagePeriod = requestedPeriod => {
  const period = Number.parseInt(String(requestedPeriod || ''), 10);
  return AI_USAGE_PERIODS.has(period) ? period : 30;
};

export const aiUsageEventLabelKey = eventType =>
  EVENT_LABEL_KEYS[String(eventType || '').toLowerCase()] || 'UNKNOWN';

export const normalizeAiCreditSnapshot = snapshot => {
  return {
    baseMonthlyLimitCents: firstNonNegativeNumber(
      snapshot?.base_monthly_limit_cents
    ),
    monthlySpentMicros: firstNonNegativeNumber(snapshot?.monthly_spent_micros),
    monthlyRemainingMicros: firstNonNegativeNumber(
      snapshot?.monthly_remaining_micros
    ),
    walletCreditCents: firstNonNegativeNumber(snapshot?.wallet_credit_cents),
    walletSpentMicros: firstNonNegativeNumber(snapshot?.wallet_spent_micros),
    walletRemainingMicros: firstNonNegativeNumber(
      snapshot?.wallet_remaining_micros
    ),
    remainingMicros: firstNonNegativeNumber(snapshot?.remaining_micros),
    unlimited: snapshot?.unlimited === true,
    exceeded: snapshot?.exceeded === true,
  };
};
